import React, { Suspense } from 'react'
import { FaSpinner } from 'react-icons/fa'
import { MdErrorOutline } from 'react-icons/md'

interface IconProps {
  pack: string
  name: string
}

const iconPackages = {
  fa: () => import('react-icons/fa'),
  ci: () => import('react-icons/ci'),
  fa6: () => import('react-icons/fa6')
}

export const Icon = ({ pack, name }: IconProps) => {
  const loadPackage = iconPackages[pack]
  if (!loadPackage) return <MdErrorOutline />

  const LazyIcon = React.lazy(async () => {
    const module = await loadPackage()
    const Component = module[name]
    return {
      default: Component || (() => <FaSpinner className='animate-spin' />)
    }
  })

  return (
    <Suspense fallback={<FaSpinner className='animate-spin' />}>
      <LazyIcon />
    </Suspense>
  )
}
